import {InjectionToken} from "@angular/core";
import {TriggerMap} from "./trigger.map";
import {ActionMap} from "./action.map";

export const MBG_TRIGGER = new InjectionToken<TriggerMap>('trigger');
export const MBG_ACTION = new InjectionToken<ActionMap>('action');